'use client';

import { LuShieldCheck } from 'react-icons/lu';
import Link from '@eliadmin/core/src/components/link';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { DialogClose, DialogContent } from '../ui/dialog';
import { Heading } from '../ui/heading';
import { Paragraph } from '../ui/paragraph';
import { Button } from '../ui/button';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { SheetClose } from '../ui/sheet';

export function ProfileSuccessPasswordChangeDialog() {
  const { t } = useTranslations();

  return (
    <DialogContent
      overlayClassName="bg-black/30 backdrop-blur-none"
      hideClose={true}
      className={cn(
        'flex w-full max-w-[518px] flex-col items-center justify-center gap-6 rounded-[16px] border-none px-4 py-8 shadow-none sm:max-w-[518px] sm:px-8 sm:py-10 md:px-10 lg:px-12 lg:py-12',
      )}
    >
      <div className="flex w-full flex-col items-center justify-center gap-3 sm:gap-4 lg:gap-6">
        <LuShieldCheck size={48} className="text-primary" aria-hidden />
        <Heading
          title={t('text649')}
          tag="h3"
          className={{ container: 'items-center justify-center text-center' }}
        />
        <Paragraph className="w-full text-center text-[#666666]">{t('text3416')}</Paragraph>
        <DialogClose asChild>
          <Button asChild className="w-full">
            <Link prefetch={false} href={ROUTES.PROFILE()}>
              {t('text1134')}
            </Link>
          </Button>
        </DialogClose>
      </div>
    </DialogContent>
  );
}

ProfileSuccessPasswordChangeDialog.id = 'PROFILE_SUCCESS_PASSWORD_CHANGE_DIALOG';
